<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (ngModelChange)="filterChange.emit(filter)">
    <option value="contains">contient</option>
    <option value="equals">est exactement</option>
    <option value="doesNotContain">ne contient pas</option>
  </select>
  <div class="ml-2">
    <input type="text" class="form-control" [id]="filter.attribute" [name]="filter.attribute" [(ngModel)]="filter.tempValue" (ngModelChange)="filterChange.emit(filter)" />
  </div>
</div>
